import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {useEffect} from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Box from "@mui/material/Box";
import Title from "./Title";
import {red} from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import {
    Backdrop,
    BottomNavigation,
    BottomNavigationAction,
    CardHeader,
    Chip,
    ListItem, ListItemAvatar,
    Select,
    styled
} from "@mui/material";
import BugReportIcon from '@mui/icons-material/BugReport';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DoNotTouchIcon from '@mui/icons-material/DoNotTouch';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import IssueList from "./issues/issuelist";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import authService from './api-authorization/AuthorizeService'
import moment from "moment/moment";
import {Link, useNavigate} from 'react-router-dom';
import Tooltip from "@mui/material/Tooltip";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import Tab from "@mui/material/Tab";
import {AlertTitle, TabList} from "@mui/lab";
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import ExpandableText from "./moreText";
import Alert from "@mui/material/Alert";
import CheckIcon from '@mui/icons-material/Check';
import CustomPaginationActionsTable from "./reportEntryUrlTable";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DetailsIcon from '@mui/icons-material/Details';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import MoneyIcon from "@mui/icons-material/Money";
import Menu from "@mui/material/Menu";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VideoEmbed from "./project/YouTubeEmbed";
import KeyValueDisplay from "./project/KvpDisplay";
import Grid from "@mui/material/Grid";
import ScrollablePanel from "./project/ScrollablePanel";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import ReportingBlock from "./project/reportingBlock";
import UrlList from "./project/UrlList";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

/* 
    TODO: Enable call to: details/{projectId}/report/viewed/{reportEntryId}
 */

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1, // Ensure the dialog is above other elements
}));

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: (theme) =>
        Math.max.apply(Math, Object.values(theme.zIndex)) + 1, // Ensure the backdrop is above the dialog
    color: '#fff',
}));

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const BoldWord = ({ text, wordToBold }) => {
    if (typeof text !== "string") return null;
    const target = (wordToBold || "").trim();
    if (!target) return <div>{text}</div>;

    // Split the text into parts around the target word
    const escapedTarget = escapeRegExp(target);
    const parts = text.split(new RegExp(`(${escapedTarget})`, 'gi'));

    return (
        <div>
            {parts.map((part, index) => (
                // Apply bold styling if the part matches the wordToBold
                part.toLowerCase() === target.toLowerCase() ?
                    <span key={index} style={{backgroundColor:'#FFD233', fontWeight:800}}>{part}</span> :
                    part
            ))}
        </div>
    );
};


const MyStack = styled(Stack)(({ theme, isConditionTrue }) => ({
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    borderWidth: 2,
    borderStyle: 'solid',
    ...(isConditionTrue
        ? {
            borderColor: 'red',
            backgroundColor: 'rgba(255,230,230,0.2)',
        }
        : {
            borderColor: 'orange',
            backgroundColor: 'rgba(255,165,0,0.2)', // Faded orange background
        }),
}));

export default function ReportEntry({report, project, readonly = false}) {
    console.log(report);

    const [value, setValue] = React.useState(-1);
    const [issues, setIssues] = React.useState([]);
    const [newIssueNotes, setNewIssueNotes] = React.useState("");
    const [issueTitle, setNewIssueTitle] = React.useState("");
    const [newIssueStatus, setNewIssueStatus] = React.useState(1);
    const navigate = useNavigate();
    const issueStatus = [
        { "key":1, "text": "Open"} ,
        { "key":2, "text": "Hold - Pending Review"},
        { "key":3, "text": "Open - Awaiting response"},
        { "key":4, "text": "General hold"},
        { "key":100, "text": "Closed"},
        { "key":101, "text": "Closed - no action required"},
        { "key":102, "text": "Closed - resolved"},
        { "key":103, "text": "Closed - unresolved"},
        { "key":199, "text": "Closed - not an issue"}
    ];
    const [openNewIssue, setopenNewIssue] = React.useState(false);
    const handleCloseNewIssue = () => {
        setopenNewIssue(false);
    };

    const [openModal, setOpenModal] = React.useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleNewIssueStatusChange = (event) => {
        setNewIssueStatus(event.target.value);
    };
    const handleNewIssueNotesChange = (event) => {
        console.log(event);
        console.log(event.target.value);
        setNewIssueNotes(event.target.value);
    };
    const handleNewIssueTitleChange = (event) => {
        console.log(event);
        console.log(event.target.value);
        setNewIssueTitle(event.target.value);
    };
    const issueCreate = () => {
        createIssueWithNotes();
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 100,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,

    };
    const [openExistingIssue, setopenExistingIssue] = React.useState(false);
    const [existingIssue, setExistingIssue] = React.useState(-1);
    const [allOpenIssues, setAllOpenIssues] = React.useState([]);
    const handleCloseExistingIssue = () => {
        setopenExistingIssue(false);
    };



    const fetchAllOpenIssues = async () => {
        console.log('getting issues', report);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/issues/', {
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        });
        authService.followIfLoginRedirect(response);
        const data = await response.json();
        setAllOpenIssues(data.reverse());
    }

    const fetchIssues = async () => {
        console.log('getting issues', report);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/issues/report/' + report.report_entry_id + '/video/' + report.media.id, {
            //headers: !token ? {} : {'X-Authorization': `Bearer ${token}`} }
        });
        authService.followIfLoginRedirect(response);
        const data = await response.json();
        setIssues(data.reverse());
    }

    useEffect(() => {
        fetchIssues()
            // make sure to catch any error
            .catch(console.error);

        fetchAllOpenIssues().catch(console.error);
    }, [report])

    const createNoIssue = async () => {

        var req = {
            status: 199,
            channel_video_ids: [report.media.id],
            comment: "",
            title: "No issue",
            project_id: project.id

        };
        //const token = await authService.getAccessToken();

        const response = await fetch('/api/issues', {
            method: "POST",
            headers:  {/*'X-Authorization': `Bearer ${token}`,*/ 'Content-Type': 'application/json' },
            body: JSON.stringify(req)
        });
        authService.followIfLoginRedirect(response);
        const data = await response.json();
        fetchIssues();
    }
    const createIssueWithNotes = async () => {

        var req = {
            status: newIssueStatus,
            channel_video_ids: [report.media.id],
            comment: newIssueNotes,
            title: issueTitle,
            project_id: project.id
        };
        //const token = await authService.getAccessToken();

        const response = await fetch('/api/issues', {
            method: "POST",
            headers: {/*'X-Authorization': `Bearer ${token}`,*/ 'Content-Type': 'application/json' },
            body: JSON.stringify(req)
        });
        authService.followIfLoginRedirect(response);
        const data = await response.json();


        navigate('/issues/' + data.id);
    }
    const logNoIssueNoAction = async () => {
        await createNoIssue().then(()=>{
            setOpenModal(false);
            fetchIssues()
                // make sure to catch any error
                .catch(console.error);
        }).catch((er)=>{
            console.log(er);
            setOpenModal(false);
        })
    }

    const issueAssignExisting = async () =>{
        console.log('assign to existing');
        let req = {};
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/issues/' + existingIssue + '/entity/' + report.media.id + '/' + project.id, {
            method: "POST",
            headers: {/*'X-Authorization': `Bearer ${token}`,*/ 'Content-Type': 'application/json' },
            body: JSON.stringify(req)
        });
        authService.followIfLoginRedirect(response);
        if (response.ok) {
            // Redirect to "/issues/" on success
            navigate('/issues/' + existingIssue);
        } else {
            // Handle error if needed
        }
    }

    const handleExistingIssueChange = (event) => {
        console.log(event);
        console.log(event.target.value);
        setExistingIssue(event.target.value);
    };

    const getIssueStatusText = (status) => {
        const match = issueStatus.find((s) => s.key === status);
        return match ? match.text : `Unknown (${status})`;
    };

    const assignableIssues = (allOpenIssues || [])
        .filter((issue) => issue.status < 100)
        .sort((a, b) => new Date(b.last_event || b.date_created || 0) - new Date(a.last_event || a.date_created || 0));
    const extractResultKeys = (jsonData) => {
        // Array to store the keys
        let resultKeys = [];
        console.log('extract')
        console.log(jsonData);
        // Checking if 'image_data' is present and is an array

        // Iterate over each item in 'image_data'
        jsonData.forEach(item => {
            // Check if 'inference' and 'result' objects exist
            if (item.inference && item.inference.result) {
                // Add the keys of 'result' object to the array
                Object.keys(item.inference.result).forEach(key => {
                    if (!resultKeys.includes(key)) {
                        resultKeys.push(key);
                    }
                });
            }
        });


        return resultKeys;
    }
    const [downloadingScreenshot, setDownloadingScreenshot] = React.useState(false);
    const [currentDownloadId, setCurrentDownloadId] = React.useState(0);
    const slugify = (title) => {
        return title
            .trim()
            .replace(/ +/g, '-')
            .toLowerCase()
            .replace(/[^a-z0-9-]/g, '')
    }

    const doDownloadScreenshot = async (id) =>{
        console.log('downloading');
        setCurrentDownloadId(id);
        setOpenUrlLoadingBackdrop(true);
        setDownloadingScreenshot(true);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/projects/'+project.id+'/details/match/url/' + id + '/file', {
            method: "GET",
            headers: {
                'Content-Type': 'image/jpeg' // Adjust according to the image type you expect
            }
        });
        setDownloadingScreenshot(false);
        if (response.ok) {
            setOpenUrlLoadingBackdrop(false);
            // Redirect to "/issues/" on success
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = slugify(moment(currentUrlDetails.request.DateGenerated).format("DD-MM-YYYY") +"----"+ currentUrlDetails.request.Parameters.Url) + ".jpg"; // Default file name
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            setOpenUrlPreviewOpen(true);
        } else {
            // Handle error if needed
            setOpenUrlLoadingBackdrop(false);
            setScreenshotFailedOpen(true);
        }
    }

    function CustomTabVisual() {
        let c = report.report_entries.filter(p=>p.visual_only && p.visual_only === true && (p.visual_only_screenshot?.labels?.length ?? 0) > 0 && p.is_dismissed === false)
        const customLabel = (
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
                <span>Visual Matches</span> <Chip label={c.length} />
            </Stack>
        );

        return customLabel;
    }
    function CustomTabAudible() {
        let c = report.report_entries.filter(p=>!p.visual_only && p.is_dismissed === false && !p.matched_from_ocr)
        const customLabel = (

            <Box direction={"row"} spacing={2} alignItems={"center"}>
                <span>Audible matches</span>  <Chip label={c.length} />
            </Box>

        );

        return customLabel;
    }
    function CustomTabOnScreenText() {
        let c = report.report_entries.filter(p=>!p.visual_only && p.is_dismissed === false && p.matched_from_ocr)
        const customLabel = (
            <Box direction={"row"} spacing={2} alignItems={"center"}>
                <span>On-screen text</span>  <Chip label={c.length} />
            </Box>
        );
        return customLabel;
    }

    const [tabIndexvalue, settabIndexValue] = React.useState(0);

    const handleTabIndexChange = (event, newValue) => {
        settabIndexValue(newValue);
    };
    const [tabUrlIndexvalue, setUrltabIndexValue] = React.useState(0);
    const handleUrlTabIndexChange = (event, newValue) => {
        console.log(newValue);
        setUrltabIndexValue(newValue);
    };

    function CustomUrlTabAffLink() {
        let c = currentUrlDetails.aff_urls_dest_page
        const customLabel = (
            <Stack direction={"row"} spacing={2} alignItems={"center"}>
                <span>Affiliate links on page</span> <Chip label={c.length} />
            </Stack>
        );

        return customLabel;
    }
    function CustomUrlTabAllLink() {
        let c = currentUrlLinks.length;
        const customLabel = (

            <Box direction={"row"} spacing={2} alignItems={"center"}>
                <span>All Links</span>  <Chip label={c} />
            </Box>

        );

        return customLabel;
    }
    function CustomUrlTabRedirect() {
        let c = (currentUrlDetails.aff_urls_in_redirects ?? []).length;
        const customLabel = (

            <Box direction={"row"} spacing={2} alignItems={"center"}>
                <span>Affiliate Links In Redirect</span>  <Chip label={c} />
            </Box>

        );

        return customLabel;
    }
    const EmptyState = ({ title, body, tip }) => (
        <Alert
            severity="info"
            variant="outlined"
            icon={<InfoOutlinedIcon />}
            sx={{ my: 2, p: 2, borderStyle: "dashed", borderRadius: 2 }}
        >
            <AlertTitle sx={{ fontWeight: 700 }}>{title}</AlertTitle>
            <Typography variant="body2" color="text.secondary">{body}</Typography>
            {tip && (
                <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                    <em>Tip:</em> {tip}
                </Typography>
            )}
        </Alert>
    );
    const formatTS = (s) => moment.utc(s * 1000).format("mm:ss");

    function visualMatches() {
        const rows = report.report_entries.filter(
            (p) =>
                p.visual_only &&
                p.visual_only === true &&
                (p.visual_only_screenshot?.labels?.length ?? 0) > 0 &&
                p.is_dismissed === false
        );

        return (
            <Box component="div" sx={{ p: 0 }}>
                <Typography sx={{ p: 1 }} variant="body2" color="text.secondary">
                    These timestamps show detections of brands that appear visually in the video.
                </Typography>

                {rows && rows.length === 0 && (
                    <EmptyState
                        title="No visual matches found"
                        body="We didn’t find frames that confidently show the tracked brands."
                        tip="Try widening the brand list or re-running analysis on a higher confidence threshold."
                    />
                )}

                {rows && rows.length > 0 && (
                    <TableContainer component={Paper} sx={{ maxHeight: 700, borderRadius: 2 }}>
                        <Table stickyHeader size="small" aria-label="visual matches table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700 }}>Start</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>End</TableCell>
                                    <TableCell sx={{ fontWeight: 700, minWidth: 280 }}>Labels (% confidence)</TableCell>
                                    <TableCell sx={{ fontWeight: 700, width: 340 }}>Image</TableCell>
                                    <TableCell sx={{ width: 80 }} align="right">Open</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>
                                            {renderTs(row.start_seconds)}
                                        </TableCell>

                                        <TableCell>
                                            {formatTS(row.end_seconds)} ({row.end_seconds - row.start_seconds}s)
                                        </TableCell>

                                        <TableCell>
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                                {row.visual_only_screenshot.labels.map((l, idx) => (
                                                    <Chip
                                                        key={`${row.id}-${idx}`}
                                                        size="small"
                                                        variant="outlined"
                                                        label={`${l.label} (${Math.round(l.score * 100)}%)`}
                                                        sx={{ mb: 0.5 }}
                                                    />
                                                ))}
                                            </Stack>
                                        </TableCell>

                                        <TableCell>
                                            <Box
                                                component="img"
                                                loading="lazy"
                                                src={`/api/projects/details/match/screenshot/${row.visual_only_screenshot.id}`}
                                                alt="Visual frame"
                                                sx={{
                                                    width: 320,
                                                    borderRadius: 1,
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    display: 'block'
                                                }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        );
    }

    const isYouTube = (report?.media?.channel?.channel_type || '').toLowerCase() === 'youtube';
    const ts = (s) => moment.utc(s * 1000).format('mm:ss');

    const renderTs = (seconds) =>
        isYouTube ? (
            <Button
                size="small"
                endIcon={<PlayArrowIcon />}
                component="a"
                href={`https://1855proxy.xyz/?https://youtube.com/watch?v=${report.media.video_id}&t=${seconds}`}
                target="_blank"
            >
                {ts(seconds)}
            </Button>
        ) : (
            <Typography variant="body2">{ts(seconds)}</Typography>
        );

    function audibleMatches() {
        const rows = report.report_entries.filter((p) => !p.visual_only && p.is_dismissed === false && !p.matched_from_ocr);

        return (
            <Box component="div" sx={{ p: 0 }}>
                {rows && rows.length === 0 && (
                    <EmptyState
                        title="No audible matches found"
                        body="We couldn’t detect any clips where the brand or keywords are spoken."
                        tip="Try broadening keywords for future matches."
                    />
                )}

                {rows && rows.length > 0 && (
                    <TableContainer component={Paper} sx={{ maxHeight: 700, borderRadius: 2 }}>
                        <Table stickyHeader size="small" aria-label="audible matches table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700 }}>Start</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>End</TableCell>
                                    <TableCell sx={{ fontWeight: 700, minWidth: 420 }}>Sentence / OCR</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }} align="right">Keyword</TableCell>
                                    <TableCell sx={{ fontWeight: 700, minWidth: 160 }}>Labels</TableCell>
                                    <TableCell sx={{ width: 80 }} align="right">Actions</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>
                                            {renderTs(row.start_seconds)}
                                        </TableCell>

                                        <TableCell>
                                            {formatTS(row.end_seconds)} ({row.end_seconds - row.start_seconds}s)
                                        </TableCell>

                                        <TableCell>
                                            {row.text && <BoldWord text={row.text} wordToBold={row.keyword?.keyword ?? ""} />}
                                        </TableCell>

                                        <TableCell align="right">
                                            {row.keyword && (
                                                <Chip size="small" label={row.keyword.keyword.toLowerCase()} />
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                                {extractResultKeys(row.image_data).map((k) => (
                                                    <Chip key={`${row.id}-${k}`} size="small" variant="outlined" label={k} />
                                                ))}
                                            </Stack>
                                        </TableCell>

                                        <TableCell align="right">
                                            <SegmentContextMenu r={row} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        );
    }
    
    function onScreenTextMatches() {
        const rows = report.report_entries.filter((p) => !p.visual_only && p.is_dismissed === false && p.matched_from_ocr);
        const ocrMaxDurationSeconds = report?.media?.ocr_max_duration_seconds ?? 900;
        const durationSeconds = Number(report?.media?.duration ?? 0);
        const ocrSkippedByDurationRule = rows.length === 0 && durationSeconds > ocrMaxDurationSeconds;
        const ocrSkippedDueToDuration = report?.media?.ocr_skipped_due_to_duration === true || ocrSkippedByDurationRule;
        const ocrSkipReason = report?.media?.ocr_skip_reason;
        const defaultDurationSkipReason = `OCR was not performed because video length (${durationSeconds}s) exceeds the OCR threshold (${ocrMaxDurationSeconds}s).`;
        const onScreenEmptyTitle = ocrSkippedDueToDuration ? "OCR not performed for this video" : "No on-screen text matches found";
        const onScreenEmptyBody = ocrSkippedDueToDuration
            ? (ocrSkipReason || defaultDurationSkipReason)
            : "We didn’t detect any tracked keywords in OCR text for this video.";
        const onScreenEmptyTip = ocrSkippedDueToDuration
            ? "This is expected for long videos. Reduce video length or increase OCR max duration in transcriber config."
            : "Try broadening text keywords or checking newer screenshots.";

        return (
            <Box component="div" sx={{ p: 0 }}>
                {rows && rows.length === 0 && (
                    <EmptyState
                        title={onScreenEmptyTitle}
                        body={onScreenEmptyBody}
                        tip={onScreenEmptyTip}
                    />
                )}

                {rows && rows.length > 0 && (
                    <TableContainer component={Paper} sx={{ maxHeight: 700, borderRadius: 2 }}>
                        <Table stickyHeader size="small" aria-label="on-screen text matches table">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 700 }}>Start</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }}>End</TableCell>
                                    <TableCell sx={{ fontWeight: 700, minWidth: 420 }}>On-screen text</TableCell>
                                    <TableCell sx={{ fontWeight: 700 }} align="right">Keyword</TableCell>
                                    <TableCell sx={{ fontWeight: 700, minWidth: 160 }}>Labels</TableCell>
                                    <TableCell sx={{ width: 80 }} align="right">Actions</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>
                                            {renderTs(row.start_seconds)}
                                        </TableCell>

                                        <TableCell>
                                            {formatTS(row.end_seconds)} ({row.end_seconds - row.start_seconds}s)
                                        </TableCell>

                                        <TableCell>
                                            <Chip sx={{ mr: 1 }} size="small" color="info" label="OCR" />
                                            {row.text && <BoldWord text={row.text} wordToBold={row.keyword?.keyword ?? ""} />}
                                        </TableCell>

                                        <TableCell align="right">
                                            {row.keyword && (
                                                <Chip size="small" label={row.keyword.keyword.toLowerCase()} />
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                                {extractResultKeys(row.image_data).map((k) => (
                                                    <Chip key={`${row.id}-${k}`} size="small" variant="outlined" label={k} />
                                                ))}
                                            </Stack>
                                        </TableCell>

                                        <TableCell align="right">
                                            <SegmentContextMenu r={row} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        );
    }

    async function startDismiss(r){
        console.log('dismissing', r);
        setOpenUrlLoadingBackdrop(true);
        //const token = await authService.getAccessToken();
        const response = await fetch('/api/projects/details/'+project.id+'/pre/' + report.report_entry_id + '/segment/'+r.id+'/dismiss', {
            method: "POST"
        });
        if (response.ok) {
            setOpenUrlLoadingBackdrop(false);
            report.report_entries = report.report_entries.filter(e=>e.id != r.id);

        }
    }

    function SegmentContextMenu({r}) {
        const [anchorEl2, setAnchorEl2] = React.useState(null);
        const openSegmentDismis = Boolean(anchorEl2);
        const handleClick2 = (event) => {
            setAnchorEl2(event.currentTarget);
        };
        const handleClose2 = () => {
            setAnchorEl2(null);
        };

        return (
            <div>
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={openSegmentDismis ? 'long-menu' : undefined}
                    aria-expanded={openSegmentDismis ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick2}
                >
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    id="long-menu"
                    MenuListProps={{
                        'aria-labelledby': 'long-button',
                    }}
                    anchorEl={anchorEl2}
                    open={openSegmentDismis}
                    onClose={handleClose2}

                >
                    <MenuItem key={1} onClick={()=>{startDismiss(r)}}>
                        Dismiss
                    </MenuItem>
                </Menu>
            </div>
        );
    }

    const [openUrlLoadingBackdrop, setOpenUrlLoadingBackdrop] = React.useState(false);
    const [screenshotFailedOpen, setScreenshotFailedOpen] = React.useState(false);
    const [openUrlPending, setUrlPendingOpen] = React.useState(false);
    const [openUrlPreviewOpen, setOpenUrlPreviewOpen] = React.useState(false);
    const [currentUrlDetails, setCurrentUrlDetails] = React.useState({"brands":[],"aff_urls_dest_page":[],"request":{"Parameters": {"Url": ""}}})
    const [currentUrlLinks, setCurrentUrlLinks] = React.useState([]);
    const [currentScreenshotObjective, setCurrentScreenshotObjective] = React.useState({});
    const [downloadAvailable, setDownloadAvailable] = React.useState(false);
    const [redirects, setRedirects] = React.useState([]);

    const handleScreenshotfailedClose = () => {
        setScreenshotFailedOpen(false);
    }
    const handleUrlPendingClose = () => {
        setUrlPendingOpen(false);
    };

    const handleBackdropClose = () => {
        //do nothing
    };
    const handleUrlPreviewClose = () => {
        setOpenUrlPreviewOpen(false);
    };
    const handleScreehotFailedClose = () => {
        setOpenUrlPreviewOpen(true);
        setScreenshotFailedOpen(false);
    }
    const [showUrlNotAnalyzedDialog, setShowUrlNotAnalyzedDialog] = React.useState(false);

    const openPreview = (urlId) => {
        console.log(urlId);
        setCurrentDownloadId(urlId);
        setOpenUrlLoadingBackdrop(true);
        setDownloadAvailable(false);
        setCurrentUrlLinks([]);
        setCurrentScreenshotObjective({});
        setRedirects([]);
        fetch("/api/projects/" + project.id + "/details/match/url/" + urlId + "/details", {
            method: "GET"
        })
            .then(async (response) => {
                const contentType = response.headers.get('content-type');
                setOpenUrlLoadingBackdrop(false);

                if (response.status === 204) {
                    setUrlPendingOpen(true);
                } else if (response.status === 202) {
                    setShowUrlNotAnalyzedDialog(true); // Show info dialog
                } else {
                    const data = await response.json();
                    setCurrentUrlDetails(data);
                    setOpenUrlPreviewOpen(true);

                    const screenshotObjective = data.request.Objectives.find(x => x.Type === "screenshot");
                    if (screenshotObjective) {
                        setCurrentScreenshotObjective(screenshotObjective);
                        setDownloadAvailable(true);
                    }

                    const linkObjective = data.request.Objectives.find(x => x.Type === "links");
                    if (linkObjective) {
                        setCurrentUrlLinks(linkObjective.Result.Links);
                    }

                    const redirectObjective = data.request.Objectives.find(x => x.Type === "redirect");
                    if (redirectObjective) {
                        setRedirects(redirectObjective.Result.Urls);
                    }
                }
            })
            .catch(() => {
                setOpenUrlLoadingBackdrop(false);
                console.log('No internet connection found. App is running in offline mode.');
            });
    }

    function downloadScreenshot(){
        setOpenUrlLoadingBackdrop(true);
        setOpenUrlPreviewOpen(false);
        doDownloadScreenshot(currentDownloadId).then((r)=>{console.log('')})
    }

    function loadingUrlBackdrop() {
        return (<StyledBackdrop
            sx={{ color: '#fff' }}
            open={openUrlLoadingBackdrop}
            onClick={handleBackdropClose}
        >
            <CircularProgress color="inherit" />
        </StyledBackdrop>)
    }

    const [actionValue, setActionValue] = React.useState(null);

    const actions = [
        {
            label: "New Issue",
            description: "Report a new bug or issue that hasn’t been logged yet.",
            icon: <BugReportIcon />,
            onClick: () => setopenNewIssue(true),
        },
        {
            label: "Assign Existing",
            description: "Link this case to an existing issue already in the system.",
            icon: <AssignmentIcon />,
            onClick: () => setopenExistingIssue(true),
        },
        {
            label: "No Issue",
            description: "Mark that no issue is relevant for this case.",
            icon: <DoNotTouchIcon />,
            onClick: () => {
                setOpenModal(true);
                logNoIssueNoAction();
            },
        },
    ]

    const handleNewIssue = () => setopenNewIssue(true);
    const handleAssignExisting = () => setopenExistingIssue(true);
    const handleNoIssue = () => {
        setOpenModal(true);
        logNoIssueNoAction();
    };

    let brandsInContent = report.brand_matches && report.brand_matches.length > 0;
    let linksInContent = report.brand_matches && report.brand_matches.filter(e=>e.links_redirects === true ||
        e.links_dest_links === true || e.links_url === true).length > 0;
    let titleContent = report.brand_matches && report.brand_matches.filter(e=>e.found_in_title === true).length > 0;
    let descriptionContent = report.brand_matches && report.brand_matches.filter(e=>e.found_in_description === true).length > 0;
    let visualInContent = report.brand_matches && report.brand_matches.filter(e=>e.visual_matches === true).length > 0;
    const hasNoActionIssue = (issues || []).some((issue) => issue.status === 199);
    let isSerious = (brandsInContent === true && linksInContent === true && visualInContent === true );
    return (
        <div>

            <Box component="div" sx={{ p: 1, borderBottom: 1, borderColor: 'divider' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <VideoEmbed
                            channel_type={report.media.channel.channel_type}
                            videoId={report.media.video_id}
                            channelHandle={report.media.channel.handle}
                            channelUrl={report.media.channel.channel_url}
                        />

                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Title sx={{mb:0,p:0,m:0}}>Description</Title>
                        <small sx={{m:0}}>This is the description of the video, at the time it was analysed.</small>
                        <Divider sx={{mb:2}}/>
                        <ScrollablePanel title="Notes" text={report.description_at_report}>


                        </ScrollablePanel>

                    </Grid>
                </Grid>

            </Box>
           

                <ReportingBlock
                    report={report}
                    linksInContent={linksInContent}
                    visualInContent={visualInContent}
                    titleContent={titleContent}
                    descriptionContent={descriptionContent}
                    isSerious={isSerious}
                    readonly={hasNoActionIssue}
                    onNewIssue={handleNewIssue}
                    onAssignExisting={handleAssignExisting}
                    onNoIssue={handleNoIssue}
                />

            
            <Box component="div" sx={{ p: 0, borderBottom: 1, borderColor: 'divider' }}>

                <Box sx={{px:1}}>
                    <Title>Matches & Results</Title>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabIndexvalue} onChange={handleTabIndexChange} aria-label="" sx={{opacity:1}} >
                            <Tab label={CustomTabAudible()} {...a11yProps(0)} sx={{ opacity: 1 }}/>
                            <Tab label={CustomTabOnScreenText()} {...a11yProps(1)} sx={{ opacity: 1 }}/>
                            <Tab label={CustomTabVisual()} {...a11yProps(2)} sx={{ opacity: 1 }}/>

                        </Tabs>
                    </Box>
                    <CustomTabPanel value={tabIndexvalue} index={0}>
                        {audibleMatches()}
                    </CustomTabPanel>
                    <CustomTabPanel value={tabIndexvalue} index={1}>
                        {onScreenTextMatches()}
                    </CustomTabPanel>
                    <CustomTabPanel value={tabIndexvalue} index={2} sx={{backgroundColor:"#efefef"}}>
                        {visualMatches()}
                    </CustomTabPanel>
                </Box>
            </Box>
            <Box component="div" sx={{ mb:3, p: 1, pb:3, borderBottom: 1, borderColor: 'divider' }}>
                <Title>Related issues from other projects</Title>

                <Box>
                    {issues && issues.length > 0 && (
                        <IssueList issues={issues} />
                    )}
                    {!issues || issues && issues.length == 0 && (
                        <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                            <Box width="30%">
                                <Alert icon={<CheckIcon fontSize="inherit" />} variant="outlined" severity="success">
                                    This video has no related issues.
                                </Alert>
                            </Box>
                        </Box>
                    )}
                </Box>
            </Box>

            <UrlList
                report={report}
                onOpenDetails={(id) => openPreview(id)}
                downloadingScreenshot={downloadingScreenshot}
            />
            
            <Box component="div" sx={{ p: 1, borderBottom: 1, borderColor: 'divider' }}>
                <Title>Details</Title>
                <KeyValueDisplay data={{
                    'Report Id': report.report_entry_id,
                    'Video Id (Digitals)': report.media.id,
                    'Video Id': report.media.video_id,
                    'Channel id': report.media.channel.id,
                    'Source': report.media.channel.channel_type,
                    'Is Affiliate': report.media.channel.is_affiliate ? 'yes' : 'no',
                    'Date discovered': moment(report.media.date_received).format('YYYY-MM-DD HH:mm'),
                }} />
            </Box>
            
            <Dialog open={openNewIssue} onClose={handleCloseNewIssue}>
                <DialogTitle>New issue</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <DialogContentText>
                            Enter details about the new issue
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="issue_title"
                            label="Issue Title (optional)"
                            type="text"
                            fullWidth
                            variant="standard"
                            value={issueTitle}
                            onChange={handleNewIssueTitleChange}
                        />
                        <TextField
                            autoFocus
                            margin="dense"
                            id="notes"
                            label="Issue notes"
                            rows={4}
                            fullWidth
                            multiline
                            variant="standard"
                            value={newIssueNotes}
                            onChange={handleNewIssueNotesChange}
                        />

                        <Select
                            value={newIssueStatus}
                            label="Status" fullWidth
                            onChange={handleExistingIssueChange}
                        >
                            {issueStatus.map((issue) => {
                                return (
                                    <MenuItem value={issue.key} key={issue.key}>{issue.text}</MenuItem>
                                );
                            })}
                        </Select>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseNewIssue}>Cancel</Button>
                    <Button onClick={issueCreate}>Open issue</Button>
                </DialogActions>
            </Dialog>

            <Modal key={2}
                   open={openModal}
                   onClose={handleCloseModal}
                   aria-labelledby="modal-modal-title"
                   aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <CircularProgress />
                </Box>
            </Modal>

            <Dialog open={openExistingIssue} onClose={handleCloseExistingIssue}>
                <DialogTitle>Existing issue</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Select an open issue to link this report entry.
                    </DialogContentText>


                        <Select
                            value={existingIssue}
                            label="Existing issue"
                            fullWidth
                            displayEmpty
                            onChange={handleExistingIssueChange}
                            sx={{ mt: 1 }}
                        >
                            <MenuItem value={-1} disabled>
                                Select issue...
                            </MenuItem>
                            {assignableIssues.map((issue) => {
                                const title = issue.issue_title || issue.title || "Untitled issue";
                                const updated = issue.last_event || issue.date_created;
                                return (
                                    <MenuItem value={issue.id} key={issue.id}>
                                        <Box sx={{ display: "flex", flexDirection: "column", py: 0.25 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                                #{issue.id} - {title}
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                {getIssueStatusText(issue.status)}
                                                {updated ? ` | Updated ${moment(updated).fromNow()}` : ""}
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseExistingIssue}>Cancel</Button>
                    <Button onClick={issueAssignExisting} disabled={existingIssue < 0}>Open issue</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openUrlPending}
                onClose={handleUrlPreviewClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Waiting to analyse results"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        This URL has not yet been analysed. Check back later
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUrlPendingClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={screenshotFailedOpen}
                onClose={handleScreenshotfailedClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Sorry :("}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        We tried to make a screenshot, but it failed. Sometimes that happens.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleScreehotFailedClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <StyledDialog open={openUrlPreviewOpen} onClose={handleUrlPreviewClose}
                          maxWidth={"xl"} fullWidth={true}>
                <DialogTitle>URL Details </DialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        <Stack direction="row" spacing={2} alignItems={"center"}>
                            <strong><span>URL:</span></strong>
                            <Chip label={((currentUrlDetails.request.Parameters.Url.length > 200) ? currentUrlDetails.request.Parameters.Url.substring(0, 200) + "..." : currentUrlDetails.request.Parameters.Url)} />
                        </Stack>
                    </Typography>
                    <Typography gutterBottom>
                        <Stack direction="column" spacing={0}>
                            <Box><strong>Date Analysied:</strong> {moment(currentUrlDetails.request.DateGenerated).format("DD MMM YYYY HH:mm")}</Box>
                            <Typography sx={{pt:0}} variant="caption" display="block" gutterBottom>This date may predate the video if we have analysed this URL previously</Typography>
                        </Stack>
                    </Typography>
                    <Stack direction={"column"} spacing={1} sx={{mb:1}}>
                        <Typography gutterBottom>
                            <strong>Response Status:</strong> {currentUrlDetails.request.ResponseStatus}
                        </Typography>
                        {currentUrlDetails && currentUrlDetails.request.ResponseStatus === 0 && (
                            <Alert icon={<ReportProblemIcon fontSize="inherit" />} variant="outlined" severity="error">
                                This status indicates we could not reach the URL in question. Network errors, server issues etc can cause this. Not all information shown may be accurate.
                            </Alert>
                        )}

                        {currentUrlDetails && (currentUrlDetails.request.ResponseStatus === 300 || currentUrlDetails.request.ResponseStatus === 301)  && (
                            <Alert icon={<ReportProblemIcon fontSize="inherit" />} variant="outlined" severity="warning">
                                This URL sends visitors to another web page.
                            </Alert>
                        )}

                    </Stack>

                    <Typography gutterBottom>
                        <strong>Links On Page:</strong> {currentUrlLinks.length} found on page
                    </Typography>


                    <Typography gutterBottom>
                        <strong>Redirected?</strong>
                        <Box>
                            <Stack direction="row" spacing={2} alignItems={"center"}>
                                {redirects.length > 0 && (<span><CheckIcon  color="success" /> Final Url: {redirects[redirects.length-1]}</span>)}
                                {!redirects || redirects && redirects.length == 0 && (
                                    <Stack direction="row" spacing={2} alignItems={"center"}>
                                        <CancelIcon color="action" /> <span>No redirects where detected.</span>
                                    </Stack>
                                )}

                            </Stack>
                        </Box>
                    </Typography>


                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabUrlIndexvalue} onChange={handleUrlTabIndexChange} aria-label="" sx={{opacity:1}} >
                            <Tab label={CustomUrlTabAffLink()} {...a11yProps(0)} sx={{ opacity: 1 }}/>
                            <Tab label={CustomUrlTabRedirect()} {...a11yProps(1)} sx={{ opacity: 1 }}/>


                            <Tab label={CustomUrlTabAllLink()} {...a11yProps(2)} sx={{ opacity: 1 }}/>
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={tabUrlIndexvalue} index={1}>
                        <Box  sx={{p:0}}>

                            <CustomPaginationActionsTable rows={currentUrlDetails.aff_urls_in_redirects} />
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabUrlIndexvalue} index={0} sx={{backgroundColor:"#efefef"}}>
                        <Box sx={{p:0}}>
                            <Box sx={{p:2}}>
                                <Typography gutterBottom>
                                    <Stack direction="column" spacing={0}>
                                        <Box><strong>Brands linked on page:</strong> {currentUrlDetails.brands && currentUrlDetails.brands.filter(e=>e.dest_page && e.dest_page === true).map((row) => (
                                            <Chip label={row.organisation_brand.name} />
                                        ))}</Box>
                                    </Stack>
                                </Typography>
                            </Box>
                            <CustomPaginationActionsTable rows={currentUrlDetails.aff_urls_dest_page} />
                        </Box>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabUrlIndexvalue} index={2}>
                        <Box  sx={{p:0}}>
                            <CustomPaginationActionsTable rows={currentUrlLinks} />
                            <Typography sx={{pt:2}} variant="caption" display="block" gutterBottom>Note: We do not analyse these links, they where found on {currentUrlDetails.request.Parameters.Url}</Typography>
                        </Box>
                    </CustomTabPanel>

                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>{downloadScreenshot()}} variant="outlined" color="success">Download Screenshot</Button>
                    <Button onClick={()=>{setOpenUrlPreviewOpen(false)}} variant="outlined" color="error">Close</Button>
                </DialogActions>
            </StyledDialog>
            <Dialog
                open={showUrlNotAnalyzedDialog}
                onClose={() => setShowUrlNotAnalyzedDialog(false)}
                aria-labelledby="url-not-analyzed-dialog-title"
            >
                <DialogTitle id="url-not-analyzed-dialog-title">Information</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This URL has not been analysed. We currently have no information about it.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowUrlNotAnalyzedDialog(false)} color="primary">
                        Dismiss
                    </Button>
                </DialogActions>
            </Dialog>
            {loadingUrlBackdrop()}
        </div>
    );
}
